type Environment =
  | 'production'
  | 'demo-production'
  | 'staging'
  | 'development'
  | 'local';

export function isTestEnvironment() {
  return process.env.NODE_ENV === 'test';
}

export const getHostname = (): string => {
  if (typeof window === 'undefined') {
    return '';
  }
  return window.location.hostname;
};

export const getEnvironmentFromHostname = (hostname: string): Environment => {
  if (hostname.endsWith('.demo.flywire.com')) {
    return 'demo-production';
  }

  if (hostname.endsWith('.flywire.com')) {
    return 'production';
  }

  if (hostname.endsWith('.flywire.lol')) {
    return 'staging';
  }

  if (hostname.endsWith('.flywire.cc')) {
    const matches = hostname.match(/payment-dev-(.+?)\.flywire\.cc/);
    return matches ? (matches[1] as Environment) : 'development';
  }

  return 'local';
};

export const getEnvironment = (): Environment => {
  return getEnvironmentFromHostname(getHostname());
};

export const getSentryEnvironment = (): Environment | undefined => {
  const environment = getEnvironment();

  if (environment === 'local') {
    return undefined;
  }

  return environment;
};
